var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDischargeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_73_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8423 8.76901L10.19 1.24803C9.53381 0.60302 8.46615 0.603056 7.81 1.248L0.157713 8.76901C-0.050025 8.9732 -0.0529078 9.30708 0.151245 9.51478C0.355397 9.72245 0.689276 9.7254 0.896979 9.52125L1.49249 8.93593V14.9405C1.49249 16.2061 2.52215 17.2358 3.78774 17.2358H14.2123C15.4779 17.2358 16.5075 16.2061 16.5075 14.9405V8.93593L17.103 9.52125C17.2057 9.62214 17.3392 9.67249 17.4726 9.67249C17.6091 9.67249 17.7455 9.61983 17.8488 9.51481C18.0529 9.30708 18.05 8.9732 17.8423 8.76901ZM15.4528 14.9405C15.4528 15.6245 14.8963 16.1811 14.2122 16.1811H3.78774C3.1037 16.1811 2.54718 15.6245 2.54718 14.9405V7.89935L8.5493 2.0002C8.61142 1.93913 8.68331 1.89333 8.76006 1.86277C8.9711 1.77882 9.21896 1.81029 9.40237 1.95724C9.41903 1.9706 9.43517 1.98491 9.45071 2.0002L15.4528 7.89931V14.9405H15.4528Z",
    fill: "#1C452B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41552 6.92511V8.62214H5.71838C5.42715 8.62214 5.19104 8.85825 5.19104 9.14948V11.2541C5.19104 11.5454 5.42715 11.7815 5.71838 11.7815H7.41552V13.4785C7.41552 13.7697 7.65163 14.0058 7.94286 14.0058H10.0475C10.3388 14.0058 10.5749 13.7697 10.5749 13.4785V11.7815H12.2717C12.563 11.7815 12.7991 11.5454 12.7991 11.2541V9.14948C12.7991 8.85825 12.563 8.62214 12.2717 8.62214H10.5749V6.92511C10.5749 6.63388 10.3388 6.39777 10.0475 6.39777H7.94286C7.65163 6.39777 7.41552 6.63388 7.41552 6.92511ZM8.4702 9.14948V7.45245H9.52018V9.14948C9.52018 9.44072 9.75629 9.67683 10.0475 9.67683H11.7444V10.7268H10.0475C9.75629 10.7268 9.52018 10.9629 9.52018 11.2541V12.9511H8.4702V11.2541C8.4702 10.9629 8.23409 10.7268 7.94286 10.7268H6.24573V9.67683H7.94286C8.23409 9.67683 8.4702 9.44072 8.4702 9.14948Z",
    fill: "#1C452B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_73_102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDischargeIcon);
export default __webpack_public_path__ + "static/media/dischargeIcon.99cb9dc7b2fb009a8cfc9fc8464e7b8b.svg";
export { ForwardRef as ReactComponent };